import { Box, Container, Grid } from "@mui/material";
import {
  DollarSign,
  Building2,
  CreditCard,
  Plane,
  TrendingUp,
  ShoppingCart,
  Award,
} from "lucide-react";
import SectionTitle from "../UI/SectionTitle";
import BenefitCard from "../UI/BenefitCard";

const benefits = [
  {
    icon: <DollarSign size={40} />,
    title: "Commission Cash Bonuses",
    description:
      "Earn more with every sale—we offer payouts above retail on select deals, ensuring you profit per item sold.",
  },
  {
    icon: <ShoppingCart size={40} />,
    title: "Retailer Cashback Benefits",
    description:
      "Get extra savings on your purchases through cashback programs from top platforms like Rakuten and RetailMeNot.",
  },
  {
    icon: <CreditCard size={40} />,
    title: "Credit Card Rewards & Cashback",
    description:
      "Earn cashback on every transaction when using our partnered credit cards, maximizing your spending power.",
  },
  {
    icon: <Plane size={40} />,
    title: "Travel Points & Air Miles",
    description:
      "Accumulate air miles on every eligible purchase, helping you save on flights, hotels, and travel expenses.",
  },
  {
    icon: <TrendingUp size={40} />,
    title: "Build & Strengthen Credit",
    description:
      "Increase your revenue while expanding your credit line, allowing for greater financial flexibility.",
  },
  {
    icon: <Award size={40} />,
    title: "Exclusive Status Tiers & Perks",
    description:
      "The more you sell, the more you earn—unlock higher-tier roles with VIP perks, increased payouts, faster processing times, and exclusive rewards.",
  },
];

export default function Benefits() {
  return (
    <Box sx={{ py: 8, bgcolor: "background.default" }}>
      <Container>
        <SectionTitle
          title="Why join RSC"
          subtitle="Maximize your earnings with exclusive benefits and rewards tailored to your success."
        />
        <Grid container spacing={4}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <BenefitCard {...benefit} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
